import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { LoadingService } from '../../../core/services/loading.service';
import {
  IActionOption,
  IColumn,
  IDataTable,
  IPageConfig,
} from '../../../core/interfaces/data-table.interface';
import { MenuItem, TreeNode } from 'primeng/api';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ColumnDataType } from '../../../core/utils/enums';
import { Table, TableModule, TablePageEvent } from 'primeng/table';
import { TreeTableModule, TreeTablePaginatorState } from 'primeng/treetable';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';
import { MenuModule } from 'primeng/menu';
import { MapPipe, TableFieldPipe } from '../../pipes';
import { SkeletonModule } from 'primeng/skeleton';
import { LoadingComponent } from '../loading/loading.component';
import { StyleClassModule } from 'primeng/styleclass';
import { OverlayPanelModule } from 'primeng/overlaypanel';

enum SelectionMode {
  Single = 'single',
  Checkbox = 'multiple',
}

@Component({
  selector: 'eco-table',
  templateUrl: './eco-table.component.html',
  styleUrl: './eco-table.component.scss',
  imports: [
    CommonModule,
    TableModule,
    TreeTableModule,
    TranslateModule,
    FormsModule,
    TableFieldPipe,
    // DecimalPipe,
    PaginatorModule,
    MenuModule,
    MapPipe,
    SkeletonModule,
    LoadingComponent,
    StyleClassModule,
    OverlayPanelModule
  ],
})
export class EcoTableComponent implements OnInit {
  @Input() columns: IColumn[] = [];
  @Input() actions: IActionOption[] = [];
  @Input() paginator = true;
  @Input() showHeader = true;
  @Input() showOrderNumber = true;
  @Input() scrollable = true;
  @Input() virtualScroll = false;
  @Input() loading = false;
  @Input() keyRow: string = 'ID';
  @Input() actionMode: 'icon' | 'menu' = 'icon';
  @Input() selectionMode: 'single' | 'multiple' | null = null;
  @Input() selectedItems: any;
  @Input() selectedRow: any;
  @Input() frozenValue: any[] = [];
  /** Nếu true, cột STT sẽ được fix cứng (sticky) bên trái */
  @Input() frozenOrderNumber = false;
  @Input() treeTable = false;
  @Input() dataTable?: IDataTable;
  @Input() dataTree?: TreeNode[];
  @Input() footerTable?: TemplateRef<any>;
  @Input() pageConfig: IPageConfig = {
    page: 0,
    size: 10,
    totalRecords: 0,
  };
  @Output() onPageChange: EventEmitter<{ page: number; size: number }> =
    new EventEmitter();
  @Output() selectedItemsChange: EventEmitter<any[]> = new EventEmitter<any>();
  @Output() onDbClickRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClickRow: EventEmitter<any> = new EventEmitter<any>();
  // @Output() onAction: EventEmitter<{ type: string; item: any }> = new EventEmitter<{
  //   type: string;
  //   item: any;
  // }>();
  @Output() onLazyLoad: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('table') table: Table | undefined;
  items: MenuItem[] = [];
  itemFocus: any;
  columnDataType = ColumnDataType;
  lastId = 0;
  SelectionMode = SelectionMode;
  currentPageReportTemplate: string = '';
  isMobile = false;

  constructor(
    public loadingService: LoadingService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
  ) {
    this.getReportTable();
    translate.onLangChange.subscribe(() => {
      this.getReportTable();
    });
  }

  getReportTable() {
    this.translate.get('table.report').subscribe((translatedString: string) => {
      this.currentPageReportTemplate = translatedString;
    });
  }
  ngOnInit() {
    this.checkScreen();
    window.addEventListener('resize', () => this.checkScreen());
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreen();
  }

  checkScreen() {
    const mobile = window.innerWidth < 992;
    if (mobile !== this.isMobile) {
      this.isMobile = mobile;
      this.cdr.detectChanges();
    }
  }
  toMenuItems<T>(options: IActionOption<T>[], row: T): MenuItem[] {
    return options.map((opt) => ({
      label: typeof opt.label === 'function' ? (opt.label as Function)(row) : opt.label,
      icon: typeof opt.icon === 'function' ? (opt.icon as Function)(row) : opt.icon,
      styleClass: typeof opt.class === 'function' ? (opt.class as Function)(row) : (opt.class ?? ''),
      visible: opt.visible ? opt.visible(row) : true,
      command: () => opt.func?.(row),
    }));
  }

  getActionIcon(opt: IActionOption, row: any): string {
    if (typeof opt.icon === 'function') {
      return (opt.icon as Function)(row);
    }
    return opt.icon || '';
  }

  getActionLabel(opt: IActionOption, row: any): string {
    if (typeof opt.label === 'function') {
      return (opt.label as Function)(row);
    }
    return opt.label || '';
  }

  getActionClass(opt: IActionOption, row: any): string {
    if (typeof opt.class === 'function') {
      return (opt.class as Function)(row);
    }
    return opt.class || '';
  }

  // getActionsItem(itemRow: any) {
  //   return this.actions
  //     .filter((itemF) => !!itemF.visible && itemF.visible(itemRow))
  //     .map((itemOp, i) => {
  //       return {
  //         label: itemOp.label,
  //         icon: itemOp.icon,
  //         iconTrigger: itemOp.iconTrigger,
  //         styleClass: itemOp.class,
  //         command: () => {
  //           if (itemOp.func) {
  //             itemOp.func(itemRow);
  //           }
  //         },
  //       };
  //     });
  // }
  getActionsItem(itemRow: any): IActionOption[] {
    return this.actions.filter(
      (itemF) => !!itemF.visible && itemF.visible(itemRow),
    );
  }

  getColumnActions(itemRow: any, column: IColumn) {
    const actions = column.columnActions || [];
    return actions
      .filter((itemF) => !!itemF.visible && itemF.visible(itemRow))
      .map((itemOp) => {
        return {
          label: typeof itemOp.label === 'function' ? (itemOp.label as Function)(itemRow) : itemOp.label,
          icon: typeof itemOp.icon === 'function' ? (itemOp.icon as Function)(itemRow) : itemOp.icon,
          styleClass: typeof itemOp.class === 'function' ? (itemOp.class as Function)(itemRow) : itemOp.class,
          command: () => {
            if (itemOp.func) {
              itemOp.func(itemRow);
            }
          },
        };
      });
  }

  doClickRow(event: any, row: any) {
    const target = event.target as HTMLElement;
    if (target.closest('.p-checkbox')) {
      return;
    }
    if (target.closest('.column-action') || target.closest('.eco-row-action')) {
      return;
    }
    this.itemFocus = row;
    this.onClickRow.emit(row);
  }

  doDblClickRow(event: any, row: any) {
    this.itemFocus = row;
    if (
      event.target.classList.contains('column-action') ||
      event.target.classList.contains('eco-row-action')
    ) {
      return;
    }
    this.onDbClickRow.emit(row);
  }

  trackByHeader(_index: number, item: IColumn) {
    return item;
  }

  trackByBody(_index: number, item: IColumn) {
    return item;
  }

  onSelectionChange(selection: any) {
    if (this.selectionMode === SelectionMode.Single) {
      this.selectedItemsChange.emit([selection]);
    } else {
      this.selectedItemsChange.emit(selection);
    }
  }

  protected readonly ColumnDataType = ColumnDataType;

  pageChange(event: TablePageEvent) {
    const page = event.first / event.rows + 1 || 0;
    const size = event.rows || 15;
    this.onPageChange.emit({
      page: page,
      size: size,
    });
  }

  doClickRowTree(node: TreeNode) {
    this.itemFocus = node.data;
    this.onClickRow.emit(node.data);
  }

  doDblClickRowTree(node: TreeNode) {
    this.itemFocus = node.data;
    this.onDbClickRow.emit(node.data);
  }

  onCheckboxClick(event: MouseEvent) {
    event.stopPropagation();
  }


  /**
   * Tính offset left (px) cho các cột frozen bên trái, theo thứ tự trong columns.
   * Nếu frozenOrderNumber=true, cột STT (50px) được tính trước tiên.
   */
  get leftFrozenOffsets(): Map<string, string> {
    const map = new Map<string, string>();
    let offset = this.frozenOrderNumber ? 50 : 0;
    this.columns
      .filter(c => c.visible && c.frozen && c.frozenAlign !== 'right')
      .forEach(col => {
        map.set(col.fieldName ?? col.headerName, `${offset}px`);
        offset += parseInt(col.width ?? '0', 10);
      });
    return map;
  }

  /**
   * Tính offset right (px) cho các cột frozen bên phải, theo thứ tự ngược.
   */
  get rightFrozenOffsets(): Map<string, string> {
    const map = new Map<string, string>();
    let offset = 0;
    [...this.columns]
      .filter(c => c.visible && c.frozen && c.frozenAlign === 'right')
      .reverse()
      .forEach(col => {
        const w = col.type === ColumnDataType.Action ? 90 : parseInt(col.width ?? '0', 10);
        map.set(col.fieldName ?? col.headerName, `${offset}px`);
        offset += w;
      });
    return map;
  }

  getOrderNumStickyStyle(isHeader = false): object {
    if (!this.frozenOrderNumber) return {};
    const style: any = {
      position: 'sticky',
      left: '0px',
      'z-index': isHeader ? '4' : '2',
    };
    if (isHeader) style['top'] = '0px';
    return style;
  }

  getThStyle(col: IColumn): object {
    const style: any = {
      'width': col.width,
      'min-width': col.width,
      'max-width': col.width,
      'text-wrap': 'nowrap',
    };
    if (col.frozen) Object.assign(style, this.buildStickyStyle(col, true));
    return style;
  }

  getTdMinStyle(col: IColumn): object {
    const style: any = { 'width': col.width, 'min-width': col.width, 'max-width': col.width };
    if (col.frozen) Object.assign(style, this.buildStickyStyle(col));
    return style;
  }

  getTdMaxStyle(col: IColumn): object {
    const style: any = { 'width': col.width, 'min-width': col.width, 'max-width': col.width };
    if (col.frozen) Object.assign(style, this.buildStickyStyle(col));
    return style;
  }

  private buildStickyStyle(col: IColumn, isHeader = false): object {
    const style: any = {
      position: 'sticky',
      'z-index': isHeader ? '3' : '1',
    };
    if (isHeader) style['top'] = '0px';
    if (col.frozenAlign === 'right') {
      style['right'] = this.rightFrozenOffsets.get(col.fieldName ?? col.headerName) ?? '0px';
    } else {
      style['left'] = this.leftFrozenOffsets.get(col.fieldName ?? col.headerName) ?? '0px';
    }
    return style;
  }
}
